// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__27Ucf","legacyBtn":"MutateMid_legacyBtn__12pP8"};